// extracted by mini-css-extract-plugin
export var cancelButton = "_o7-5";
export var content = "_o7-3";
export var createButton = "_o7-6";
export var drawerContainer = "_o7-0";
export var footer = "_o7-2";
export var header = "_o7-1";
export var orderFormColumn = "_o7-4";